import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import { ControlledAddressAutofill, ControlledInput } from "shared/components";

export const LocationContactInfo = () => {
  const { t } = useTranslation();
  return (
    <Flex flexDir={"column"} gap={"200"}>
      <Flex gap={"200"}>
        <ControlledInput
          name={"website"}
          label={t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.PUBLIC_WEBSITE",
          )}
        />
        <ControlledInput
          name={"email"}
          label={t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.PUBLIC_EMAIL_ADDRESS",
          )}
          type="email"
        />
      </Flex>
      <Flex gap={"200"}>
        <ControlledInput
          name={"phone"}
          label={t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.LOCAL_PUBLIC_PHONE",
          )}
        />
        <ControlledInput
          name={"tollFreePhone"}
          label={t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.TOLL_FREE_PUBLIC_PHONE",
          )}
        />
      </Flex>
      <ControlledAddressAutofill
        addressInputName={"fullAddress"}
        addressObjInputName={"fullAddressObj"}
        coordsInputName={"fullAddressObj.location.coordinates"}
        lngInputName={"fullAddressObj.location.coordinates.lng"}
        latInputName={"fullAddressObj.location.coordinates.lat"}
      />
    </Flex>
  );
};
